import { render, staticRenderFns } from "./DatePickerElement.vue?vue&type=template&id=09518dbc&scoped=true&"
import script from "./DatePickerElement.vue?vue&type=script&lang=js&"
export * from "./DatePickerElement.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerElement.vue?vue&type=style&index=0&id=09518dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09518dbc",
  null
  
)

export default component.exports